// Dynamically load HanaMinA font from public folder
export const loadHanaMinAFont = () => {
  // Wait for DOM to be ready
  if (typeof document === 'undefined') {
    return;
  }

  // Check if font-face is already injected
  if (document.getElementById('hanamina-font-face')) {
    return;
  }

  const fontPath = `${process.env.PUBLIC_URL || ''}/fonts/花園明朝HanaMinA.ttf`;
  
  // Create and inject @font-face rule
  const fontFace = `
    @font-face {
      font-family: "HanaMinA";
      src: url("${fontPath}") format("truetype");
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  // Create style element
  const styleElement = document.createElement('style');
  styleElement.id = 'hanamina-font-face';
  styleElement.textContent = fontFace;
  document.head.appendChild(styleElement);

  // Try to load the font and verify it works
  const font = new FontFace('HanaMinA', `url("${fontPath}")`);
  
  font.load()
    .then((loadedFont) => {
      document.fonts.add(loadedFont);
      console.log('✅ HanaMinA font loaded successfully');
    })
    .catch((error) => {
      console.warn('⚠️ HanaMinA font failed to load');
      console.warn('請將字型檔案放在: public/fonts/花園明朝HanaMinA.ttf');
      console.warn('Font path:', fontPath);
      console.warn('Error details:', error);
      // Remove the @font-face rule if font fails to load
      const styleEl = document.getElementById('hanamina-font-face');
      if (styleEl) {
        styleEl.remove();
      }
    });
};

